import { JobRecruitSalaryExampleResponse } from '@doda/api-client/aspida/@types';

/**
 * 賞与テキストを生成
 * @param numberOfBonuses
 * @param bonus
 */
export const createBonusText = (
  numberOfBonuses: string | undefined,
  bonus: string | undefined
): string => {
  if (numberOfBonuses && bonus) {
    return `年${numberOfBonuses}回${bonus}`;
  }

  if (numberOfBonuses) {
    return `年${numberOfBonuses}回`;
  }

  if (bonus) {
    return bonus;
  }

  return '';
};

/**
 * 昇給テキストを生成
 * @param numberOfSalaryIncrease
 * @param raise
 */
export const createRaiseText = (
  numberOfSalaryIncrease: string | undefined,
  raise: string | undefined
) => {
  if (numberOfSalaryIncrease && raise) {
    return `年${numberOfSalaryIncrease}回${raise}`;
  }

  if (numberOfSalaryIncrease) {
    return `年${numberOfSalaryIncrease}回`;
  }

  if (raise) {
    return raise;
  }

  return '';
};

/**
 * 求人詳細 T原稿 募集要項の給与例作成処理
 * @param {Array<JobRecruitSalaryExampleResponse>} salaryExamples
 * @param max
 * @returns {strgin} 給与例テキスト
 */
export const toSalaryExamplesString = (
  salaryExamples: Array<JobRecruitSalaryExampleResponse>,
  max = 2
) => {
  const salaries = salaryExamples.slice(0, max).map((salary) => salary.text);
  return salaries.join('\n');
};
